import { render, staticRenderFns } from "./APMsg.vue?vue&type=template&id=7ccf553c&scoped=true&"
import script from "./APMsg.vue?vue&type=script&lang=js&"
export * from "./APMsg.vue?vue&type=script&lang=js&"
import style0 from "./APMsg.vue?vue&type=style&index=0&id=7ccf553c&lang=less&scoped=true&"
import style1 from "./APMsg.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf553c",
  null
  
)

component.options.__file = "APMsg.vue"
export default component.exports